
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { TerraceFormValues } from "./types";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import TerraceOrientationSelect from './TerraceOrientationSelect';

interface TerraceeFeaturesProps {
  form: UseFormReturn<TerraceFormValues>;
  disabled?: boolean;
}

const TerraceFeatures: React.FC<TerraceeFeaturesProps> = ({ form, disabled = false }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="space-y-4">
          <h3 className="text-lg font-medium text-sunset-dark">Business Features</h3>
          
          <FormField
            control={form.control}
            name="hasFood"
            render={({ field }) => (
              <FormItem className="flex flex-row items-start space-x-3 space-y-0">
                <FormControl>
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                    disabled={disabled}
                  />
                </FormControl>
                <div className="space-y-1 leading-none">
                  <FormLabel className={disabled ? "text-muted-foreground" : ""}>
                    Serves Food
                  </FormLabel>
                  <FormDescription>
                    This terrace serves food
                  </FormDescription>
                </div>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="servesAlcohol"
            render={({ field }) => (
              <FormItem className="flex flex-row items-start space-x-3 space-y-0">
                <FormControl>
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                    disabled={disabled}
                  />
                </FormControl>
                <div className="space-y-1 leading-none">
                  <FormLabel className={disabled ? "text-muted-foreground" : ""}>
                    Serves Alcohol
                  </FormLabel>
                  <FormDescription>
                    This terrace serves alcoholic beverages
                  </FormDescription>
                </div>
              </FormItem>
            )}
          />

        </div>

        <div className="space-y-4">
          <h3 className="text-lg font-medium text-sunset-dark">Accessibility & Pets</h3>
          
          <FormField
            control={form.control}
            name="allowsDogs"
            render={({ field }) => (
              <FormItem className="flex flex-row items-start space-x-3 space-y-0">
                <FormControl>
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                    disabled={disabled}
                  />
                </FormControl>
                <div className="space-y-1 leading-none">
                  <FormLabel className={disabled ? "text-muted-foreground" : ""}>
                    Dog Friendly
                  </FormLabel>
                  <FormDescription>
                    Dogs are welcome on this terrace
                  </FormDescription>
                </div>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="wheelchairAccessible"
            render={({ field }) => (
              <FormItem className="flex flex-row items-start space-x-3 space-y-0">
                <FormControl>
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                    disabled={disabled}
                  />
                </FormControl>
                <div className="space-y-1 leading-none">
                  <FormLabel className={disabled ? "text-muted-foreground" : ""}>
                    Wheelchair Accessible
                  </FormLabel>
                  <FormDescription>
                    This terrace is accessible for wheelchairs
                  </FormDescription>
                </div>
              </FormItem>
            )}
          />

          <div className="pt-4">
            <h4 className="text-md font-medium text-sunset-dark mb-2">Location Details</h4>
            <TerraceOrientationSelect form={form} disabled={disabled} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerraceFeatures;
